var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganigrama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 125V116.667C50 112.246 51.7559 108.007 54.8816 104.882C58.0072 101.756 62.2464 100 66.6667 100H133.333C137.754 100 141.993 101.756 145.118 104.882C148.244 108.007 150 112.246 150 116.667V125M100 75V100M25 141.667C25 137.246 26.7559 133.007 29.8816 129.882C33.0072 126.756 37.2464 125 41.6667 125H58.3333C62.7536 125 66.9928 126.756 70.1184 129.882C73.244 133.007 75 137.246 75 141.667V158.333C75 162.754 73.244 166.993 70.1184 170.118C66.9928 173.244 62.7536 175 58.3333 175H41.6667C37.2464 175 33.0072 173.244 29.8816 170.118C26.7559 166.993 25 162.754 25 158.333V141.667ZM125 141.667C125 137.246 126.756 133.007 129.882 129.882C133.007 126.756 137.246 125 141.667 125H158.333C162.754 125 166.993 126.756 170.118 129.882C173.244 133.007 175 137.246 175 141.667V158.333C175 162.754 173.244 166.993 170.118 170.118C166.993 173.244 162.754 175 158.333 175H141.667C137.246 175 133.007 173.244 129.882 170.118C126.756 166.993 125 162.754 125 158.333V141.667ZM75 41.6667C75 37.2464 76.7559 33.0072 79.8816 29.8816C83.0072 26.7559 87.2464 25 91.6667 25H108.333C112.754 25 116.993 26.7559 120.118 29.8816C123.244 33.0072 125 37.2464 125 41.6667V58.3333C125 62.7536 123.244 66.9928 120.118 70.1184C116.993 73.244 112.754 75 108.333 75H91.6667C87.2464 75 83.0072 73.244 79.8816 70.1184C76.7559 66.9928 75 62.7536 75 58.3333V41.6667Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganigrama);
export default __webpack_public_path__ + "static/media/Organigrama.7ec7b26c65d59980994453371bb5d683.svg";
export { ForwardRef as ReactComponent };